import React, { useState, } from 'react';
import Navbar from '../layouts/navbar';
import Parse from 'parse';
import swal from 'sweetalert';
import './faq.css';

const Query = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [query,setQuery] = useState('');


    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log(e)
        // const f = () => {
            
        // }
        // f();
        const Queries = Parse.Object.extend('Queries');
            const queries = new Queries();
    
            queries.set("name", name);
            queries.set("email", email);
            queries.set("query",query);
            queries.set("isCounsellor",false);
    
            queries.save()
                .then((data) => {
                    console.log(data);
                    swal("Addedd!", "Your query has been shared with aur team..we will be contacting you shortly", "success");
                    setName("");
                    setEmail("");
                    setQuery("");
                }).catch((error) => {
                    console.log(error);
                    swal("Oops!", "Seems like we couldn't share your query with the team...Please try again in sometime", "error");

                })        

    }
    return (
        <div>
            <Navbar head="your Query Please" />
            <div className="container" style={{marginTop:"60px"}}>
                <form onSubmit={handleSubmit}>


                    <div className="form-group col-lg-12  ">
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            placeholder="Name" />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <input
                            type="text"
                            className="form-control"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            placeholder="email id" />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <textarea
                            className="text-box querybox"
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                            placeholder="Query" />
                    </div>
                    <div className="btndiv ">
                        <input
                        type="submit"
                            className="submit btn-primary center-block mt-4" />
                    </div>
                </form>
            </div>
        </div>
    )
}
export default Query;